/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_Save_ScoresInputs */



/**
* | output |
* | --- |
* | "Failed to save scores" |
*
* @param {Tournament_Error_Save_ScoresInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_save_scores = /** @type {((inputs?: Tournament_Error_Save_ScoresInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_Save_ScoresInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'enregistrement des scores")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar puntuaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao salvar pontuações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio punteggi fallito")
	return /** @type {LocalizedString} */ ("Failed to save scores")
});